export enum RegexMatch {
  INTEGER = "\\d+",
  NEW = "new",
  SLUG = "[\\w-_]+", // eg "foo" | "foo-bar" | "foo_bar"
  UUID = "[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}"
}
